<template>
<div class="PrefabCreator_CurrentCategory" v-if="Object.keys(CurrentCategory).length > 0 ">
 <div class="PrefabCreator_CurrentCategory_title">
   <h2 style="margin-bottom: 0;text-align: left">{{ CurrentCategory.title_swe }}</h2>
   <div class="CurrentCategoryStepsHolder" style="min-width: max-content;" v-if="this.$store.state.view !== 'summary' && this.$store.state.view !== 'kassa'">
     <div class="stepsHolder" >
       <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M14.875 4.90149V11.0975C14.875 11.1689 14.8548 11.239 14.8163 11.3006C14.7778 11.3621 14.7225 11.4128 14.6561 11.4475L8.70613 14.5582C8.64305 14.5911 8.57212 14.6083 8.5 14.6083C8.42788 14.6083 8.35694 14.5911 8.29387 14.5582L2.34388 11.4475C2.27752 11.4128 2.22222 11.3621 2.18373 11.3006C2.14524 11.239 2.12496 11.1689 2.125 11.0975V4.90149C2.12509 4.83018 2.14543 4.7602 2.18391 4.69878C2.22239 4.63736 2.27762 4.58673 2.34388 4.55215L8.29387 1.44082C8.35694 1.4079 8.42788 1.39062 8.5 1.39062C8.57212 1.39062 8.64305 1.4079 8.70613 1.44082L14.6561 4.55215C14.7224 4.58673 14.7776 4.63736 14.8161 4.69878C14.8546 4.7602 14.8749 4.83018 14.875 4.90149Z" stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
         <path d="M2.49854 4.86418L8.2927 7.89352C8.35586 7.92656 8.42692 7.9439 8.49918 7.9439C8.57144 7.9439 8.6425 7.92656 8.70566 7.89352L14.5204 4.85352M8.49954 14.0015V8.00152" stroke="#061B3A" stroke-linecap="round" stroke-linejoin="round"/>
         <path d="M8.28112 7.88679L2.75613 4.99746C2.69141 4.96368 2.61845 4.94639 2.54445 4.9473C2.47046 4.94821 2.398 4.96728 2.33425 5.00264C2.27049 5.038 2.21765 5.08841 2.18095 5.14889C2.14425 5.20936 2.12496 5.27781 2.125 5.34746V11.0988C2.12496 11.1702 2.14524 11.2403 2.18373 11.3019C2.22222 11.3634 2.27752 11.4142 2.34388 11.4488L7.86888 14.3375C7.93359 14.3712 8.00655 14.3885 8.08054 14.3876C8.15454 14.3867 8.227 14.3676 8.29075 14.3323C8.35451 14.2969 8.40735 14.2465 8.44405 14.186C8.48075 14.1256 8.50004 14.0571 8.5 13.9875V8.23613C8.49991 8.16482 8.47957 8.09484 8.44109 8.03342C8.40261 7.972 8.34738 7.92138 8.28112 7.88679Z" fill="#F7D046" stroke="#061B3A" stroke-linejoin="round"/>
       </svg>
       <span>
        <span class="currentStep">{{ currentStep()}}</span>/{{ SubCategories.length + 1 }} {{ $t('steg') }}
      </span>
     </div>
   </div>
   <div style="background-color: #EDEDED;height: 1px;flex: 1"></div>
 </div>



</div>
</template>

<script>

export default {
  name: "CurrentCategory",
  computed:{
    SubCategories(){
      return this.$store.getters.SubCategories
    },
    CurrentCategory(){
      return this.$store.state.CurrentCategory
    }
  },
  methods:{
    currentStep(){
     return this.SubCategories.findIndex(x=>x.category_nr === this.CurrentCategory.category_nr)+1
    },
    ShowSelectedDecription(){
      let catNr = this.$store.state.view
      if(Number(catNr)){
      let row = this.$store.state.order.rows.find(x => x.category.category_nr === catNr)
       this.$store.commit('commit_infoArticle',row)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.PrefabCreator_CurrentCategory{
  padding: 10px 5px 15px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
  .InfoBtn{
    border-radius: 14px;
    border: 1px solid var(--gray-06, #E2E2E2);
    background: var(--gray-white, #FFF);
    display: inline-flex;
    padding: 4px 9px 4px 6px;
    align-items: center;
    gap: 10px;
    color: var(--gray-09, #8F8F8F);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    cursor: pointer;
    &:hover{
      background-color: #f7f5f5;
    }
  }
  .PrefabCreator_CurrentCategory_title{
    display: flex;
    align-items: center;
    gap: 20px;
    flex: 1;
  }
  h2{
    color: #000;
    font-size: 18px!important;
    font-style: normal;
    line-height: 147.187%;
    font-weight: 600;
    font-family: "DM Sans"!important;
  }
  .CurrentCategoryStepsHolder{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .stepsHolder{
      color: var(--gray-09, #8F8F8F);
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 130%;
      display: flex;
      align-items: flex-start;
      gap: 9px;
      .currentStep{
        color: var(--base-blue, #294F8A);
      }
    }

  }
}

</style>
